import { render } from "./ClientVentasPedidos.vue?vue&type=template&id=2626872f"
import script from "./ClientVentasPedidos.vue?vue&type=script&lang=js"
export * from "./ClientVentasPedidos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__